export default __webpack_public_path__ + "static/media/avatarPokerface.1dd0b659.png";